import { createContext } from "react";

/** @type GlobalAdDomainData */
const defaultData = {
    domainClientType: ''
}

const GlobalAdDomainDataContext = createContext(defaultData)
export default GlobalAdDomainDataContext